import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { environment } from '@environments/environment'

@Injectable({
  providedIn: 'root'
})
export class DocumentPreviewService {
  private readonly http = inject(HttpClient)
  private readonly router = inject(Router)
  private readonly apiUrl = environment.documentApiUrl

  /** The rendered certificate document as HTML. Will be swapped for the PDF once the render service is live. */
  public getPreviewHtml(certificateUuid: string): Observable<string> {
    return this.http.get(`${this.apiUrl}/preview/${certificateUuid}`, { responseType: 'text' })
  }

  public openPreview(certificateUuid: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/certificate', certificateUuid, 'preview']))
    globalThis.open(url, '_blank', 'noopener')
  }
}
